import { router } from '../actions';
import { STATES } from '../../constants';

const INSURANCE_SHOULD_SEE_SURVEY = 'INSURANCE_SHOULD_SEE_SURVEY';
const INSURANCE_DESIRED_TO_STATE = 'INSURANCE_DESIRED_TO_STATE';
const INSURANCE_SAW_SURVEY = 'INSURANCE_SAW_SURVEY';

const INSURANCE_SURVEY_PATH = '/improve-insurance';

export const actions = {
  shouldSeeSurvey: payload => ({
    type: INSURANCE_SHOULD_SEE_SURVEY,
    payload,
  }),
  desiredToState: payload => ({
    type: INSURANCE_DESIRED_TO_STATE,
    payload,
  }),
  sawSurvey: payload => ({
    type: INSURANCE_SAW_SURVEY,
    payload,
  }),
};

export function reducer(state = {}, action) {
  if (action.type === INSURANCE_SHOULD_SEE_SURVEY) {
    return {
      ...state,
      shouldSeeSurvey: action.payload,
    };
  }
  if (action.type === INSURANCE_DESIRED_TO_STATE) {
    return {
      ...state,
      desiredToState: action.payload,
    };
  }
  if (action.type === INSURANCE_SAW_SURVEY) {
    return {
      ...state,
      sawSurvey: action.payload,
    };
  }
  return state;
}

const SURVEY_CURRENT_BLACKLIST = [STATES.STEP_INSURANCE];
const SURVEY_PREVIOUS_WHITELIST = [STATES.STEP_INSURANCE];

export function epic() {
  return (action, { dispatch, getState }) => {
    let { shouldSeeSurvey, sawSurvey } = getState().insurance || {
      shouldSeeSurvey: false,
      sawSurvey: false,
    };

    if (action.payload !== null) {
      if (
        action.type === '@@reduxUiRouter/$stateChangeSuccess' &&
        !SURVEY_CURRENT_BLACKLIST.includes(action.payload.currentState.name) &&
        SURVEY_PREVIOUS_WHITELIST.includes(action.payload.prevState.name) &&
        shouldSeeSurvey &&
        !sawSurvey
      ) {
        dispatch(actions.shouldSeeSurvey(false));
        dispatch(actions.sawSurvey(true));
        dispatch(
          actions.desiredToState({
            name: action.payload.currentState.name,
            params: action.payload.currentParams,
          })
        );
        dispatch(
          router.stateGo(STATES.INSURANCE_QUESTIONNAIRE, {
            path: INSURANCE_SURVEY_PATH,
          })
        ).then(() => {
          window.scrollTo(0, 0);
        });
      }
    }
  };
}
